import { getToken } from '@/utils/auth';
import { http } from '@/utils/http';
import { badgeList } from './exhibitor-badge';

export enum UserRole {
  SuperAdmin = 'super-admin',
  Admin = 'admin',
}

export interface ISafeUser {
  id: number;
  name: string;
  boothCode: string;
  companyNameEn: string;
  roles?: string[];
}

export interface SignInBody {
  username: string;
  password: string;
}

export type UserResult = {
  success: boolean;
  data: {
    /** 头像 */
    avatar: string;
    /** 用户名 */
    username: string;
    /** 昵称 */
    nickname: string;
    /** 当前登录用户的角色 */
    roles: Array<string>;
    /** 按钮级别权限 */
    permissions: Array<string>;
    /** `token` */
    accessToken: string;
    /** 用于调用刷新`accessToken`的接口时所需的`token` */
    refreshToken: string;
    /** `accessToken`的过期时间（格式'xxxx/xx/xx xx:xx:xx'） */
    expires: Date;
  };
};

export type RefreshTokenResult = {
  success: boolean;
  data: {
    /** `token` */
    accessToken: string;
    /** 用于调用刷新`accessToken`的接口时所需的`token` */
    refreshToken: string;
    /** `accessToken`的过期时间（格式'xxxx/xx/xx xx:xx:xx'） */
    expires: Date;
  };
};

/** 登录 */
export const userLogin = (data: SignInBody) => {
  return http.post<any, string>('/pcb/api/user/login', {
    username: data.username,
    userpwd: data.password,
  });
};

export const getUserInfo = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('Not login');
  }
  const res = await badgeList();
  const name = res?.companyNameZh;
  return {
    data: {
      id: 1,
      name: name || 'Hi',
      boothCode: res?.boothCode,
      companyNameEn: res?.companyNameEn,
    } satisfies ISafeUser,
  };
};

export const userLogout = async () => {
  // no api now
  // return http.post('/logout');
};
